import PerformerCard from './PerformerCard';
// MANUAL OVERRIDE - added combined props
import { PerformerCardProps, PerformerCardValueProps, PerformerCardCombinedProps } from './types';

// MANUAL OVERRIDE - added combined props
export type { PerformerCardProps, PerformerCardValueProps, PerformerCardCombinedProps };
export default PerformerCard;
